module.exports = __webpack_public_path__ + "static/female-pic2-2d823ce20deaf9cfbccaefcc08ec7d0c.jpg";